import React, { useState, useEffect } from 'react';
import './LinkedInModal.scss';
import LinkedinImg from '../../Assets/linkedin-removebg-preview.png';

const LinkedInModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');

  // Message pool - mix of value and curiosity
const messages = [
  "🚀 Want a career upgrade? Learn job-ready tech skills and discover what companies really expect from students!",
  
  "💼 Placement season coming? Get smart interview tips, recruiter insights, and real-world questions explained daily!",
  
  "🔥 Confused about which technology to learn? Follow us for clear guidance, trending skills, and beginner-friendly roadmaps!",
  
  "🎯 Learn how to speak confidently in interviews, explain your projects smartly, and impress recruiters instantly!",
  
  "✨ Get early access to new courses, workshops, and placement drives—your next opportunity may be one follow away!",
  
  "🧠 Crack interviews faster with daily mini-lessons, simple explanations, and real examples from hiring panels!",
  
  "🌱 Turn your skills into a real career—resume tricks, portfolio ideas, and industry expectations simplified for you!",
  
  "🏆 See how freshers like you landed top jobs. Follow for inspiring success stories and practical strategies!",
  
  "📚 Learn the most in-demand skills—MERN, Python, Java, Data Analytics & more—explained in the easiest way!",
  
  "🔍 Curious how top students get shortlisted? Follow us to learn the secrets recruiters never tell openly!"
];


  // Get random message that hasn't been shown yet
  const getRandomMessage = () => {
    try {
      let shown = JSON.parse(localStorage.getItem('linkedin_modal_shown_messages') || '[]');
      
      // Filter out already shown messages
      let available = messages.filter(msg => !shown.includes(msg));
      
      // If all messages shown, reset
      if (available.length === 0) {
        shown = [];
        localStorage.removeItem('linkedin_modal_shown_messages');
        available = messages;
      }
      
      // Pick random from available
      const selectedMsg = available[Math.floor(Math.random() * available.length)];
      
      // Mark as shown
      shown.push(selectedMsg);
      localStorage.setItem('linkedin_modal_shown_messages', JSON.stringify(shown));
      
      return selectedMsg;
    } catch (error) {
      console.error('Error getting message:', error);
      return messages[0];
    }
  };

  // Check if modal should be shown
  const shouldShowModal = () => {
    try {
      // Already followed? Never show again
      if (localStorage.getItem('linkedin_modal_followed') === 'true') {
        return false;
      }

      return true;
    } catch (error) {
      console.error('Error checking show conditions:', error);
      return false;
    }
  };

  // Show modal with animation
  const showModal = () => {
    if (!shouldShowModal()) return;

    const msg = getRandomMessage();
    setMessage(msg);
    setIsVisible(true);
  };

  // Close modal
  const closeModal = () => {
    setIsVisible(false);
  };

  // Handle follow click
  const handleFollow = () => {
    localStorage.setItem('linkedin_modal_followed', 'true');
    // Open LinkedIn in new tab
    window.open('https://www.linkedin.com/company/better-tomorrow-training-institute/', '_blank');
    closeModal();
  };



  // Disable body scroll when modal is visible
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isVisible]);

  // Trigger logic: show after scroll 50% OR after random time (10-50 seconds)
  useEffect(() => {
    let triggered = false;
    let timeoutId = null;

    // Timer trigger (random between 10-50 seconds)
    const randomDelay = Math.floor(Math.random() * (50000 - 10000 + 1)) + 10000;
    timeoutId = setTimeout(() => {
      if (!triggered && shouldShowModal()) {
        triggered = true;
        showModal();
      }
    }, randomDelay);

    // Scroll trigger (40%)
    const handleScroll = () => {
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      
      if (scrollPercent >= 40 && !triggered && shouldShowModal()) {
        triggered = true;
        if (timeoutId) clearTimeout(timeoutId);
        showModal();
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      window.removeEventListener('scroll', handleScroll);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop overlay */}
      <div className="modal-backdrop" />
      
      {/* Modal card */}
      <div 
        className={`linkedin-modal ${isVisible ? 'show' : ''}`}
      >
        <div className="modal-content">
          <button className="close-btn" onClick={closeModal} aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          
          <div className="linkedin-icon">
            <img src={LinkedinImg} alt="LinkedIn Logo" />
          </div>

          <div className="modal-text">
            <h3>⚡ Don't Miss Out!</h3>
            <p>{message}</p>
          </div>

          <button className="follow-btn" onClick={handleFollow}>
            <span className="btn-icon">👉</span>
            Follow Now
          </button>
        </div>
      </div>
    </>
  );
};

export default LinkedInModal;
